// 定义一个产品配件组件
class MrkProductAccessories extends HTMLElement {
  constructor() {
    super();

    this.element = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.element = this.getElements();

    if (this.element.modelType === 'secondary') {
      this.eventBindSecondary();
      return;
    }

    this.eventBind();
    this.setItems();
  }

  getElements() {
    return {
      containerNode: this.querySelector('.product-accessories-block'),
      modelType: this.getAttribute('model-type')
    }
  }

  eventBind() {
    if (this.element.containerNode) {
      this.element.containerNode.addEventListener('click', (e) => {
        const itemNode = e.target.closest('.item');
        const variantNode = e.target.closest('.variant-option');
        const moreNode = e.target.closest('.more-block');
        const defaultSelected = e.currentTarget.getAttribute('default-selected'); // 有这个属性说明是默认选中的，不能点击
        const aNode = e.target.closest('a');
        if (aNode && aNode.tagName.toLocaleUpperCase() === 'A') return;
        if (moreNode) {
          this.setMore(moreNode)
          return;
        }

        if (defaultSelected === 'true') return;

        if (variantNode) {
          this.setVariant(variantNode);
          return;
        }
        if (itemNode) {
          this.setItme(itemNode);
          return;
        }
      })
    }
  }

  eventBindSecondary() {
    const downBtnAtt = '[down-btn]';
    const downExpandNode = this.querySelector('[down-expand]');
    const downCollapseNode = this.querySelector('[down-collapse]');
    const visibilityItemsNode = this.querySelector('[visibility-items]');
    const downIconNode = this.querySelector('[down-icon]');

    this.addEventListener('click', (e) => {
      const downBtnNode = e.target.closest(downBtnAtt);
      if (downBtnNode && downExpandNode && downCollapseNode) {
        const isOpen = downBtnNode.getAttribute('open');
        if (isOpen) {
          downBtnNode.removeAttribute('open');
          downExpandNode.style.display = '';
          downCollapseNode.classList.add('mrk-none');
          visibilityItemsNode.classList.add('mrk-none');
          downIconNode.style.transform = 'rotate(0deg)';
        } else {
          downBtnNode.setAttribute('open', true);
          downExpandNode.style.display = 'none';
          downCollapseNode.classList.remove('mrk-none');
          visibilityItemsNode.classList.remove('mrk-none');
          downIconNode.style.transform = 'rotate(180deg)';
        }
        return;
      }
    })
  }

  setItems() {
    const itemsNode = this.element.containerNode.querySelector('.accessories-items');
    if (itemsNode) {
      const itemNode = itemsNode.querySelector('.item');
      const itemHeight = itemNode.clientHeight;
      itemsNode.style.setProperty('--items-height', `${itemHeight + 6}px`);
    }
  }

  // 点击更多
  setMore(moreNode) {
    const itemsNode = this.element.containerNode.querySelector('.accessories-items');
    const isOpen = moreNode.getAttribute('open');
    if (isOpen !== null) {
      moreNode.removeAttribute('open');
      itemsNode.classList.add('max-height');
    } else {
      moreNode.setAttribute('open', true);
      itemsNode.classList.remove('max-height');
    }
  }

  // 点击配件列表
  setItme(itemNode) {
    const isChecked = itemNode.getAttribute('checked');
    if (isChecked !== null) {
      itemNode.removeAttribute('checked');
    } else {
      itemNode.setAttribute('checked', true);
    }
  }

  // 点击变体
  setVariant(variantNode) {
    const isChecked = variantNode.getAttribute('checked');
    const optionId = variantNode.getAttribute('data-option-value-id');
    if (!optionId) return;
    if (isChecked !== null) {
      // variantNode.removeAttribute('checked');
    } else {
      const itemFooterNode = variantNode.closest('.item-footer');
      const variantAllNode = itemFooterNode.querySelectorAll('.variant-option');
      variantAllNode.forEach((variantItem) => {
        variantItem.removeAttribute('checked');
      })
      variantNode.setAttribute('checked', true);

      const variantData = this.getVariantData(itemFooterNode, optionId);
      if (variantData) {
        this.setHtml(variantData, variantNode);
      }
    }
  }

  getVariantData(itemFooterNode, optionId) {
    let variantData = itemFooterNode.querySelector(`#product-variant-json-${optionId}`);
    if (variantData) {
      variantData = JSON.parse(variantData.textContent);
      return variantData;
    }
    return null;
  }

  setHtml(variantData, variantNode) {
    const itemNode = variantNode.closest('.item');
    const imageNode = itemNode.querySelector('.media-file');
    const thumbnailIs = imageNode.getAttribute('thumbnail_is');
    const priceNumNode = itemNode.querySelector('.price-num');
    const aNode = itemNode.querySelectorAll('a');
    aNode.forEach((aItem) => {
      aItem.href = variantData.url;
    })
    if (thumbnailIs == 'false' && variantData.featured_image) imageNode.setAttribute('src', variantData.featured_image);
    priceNumNode.textContent = variantData.price;
  }

  disconnectedCallback() {
  }
}
customElements.define("mrk-product-accessories", MrkProductAccessories);

// 产品图片热区
class MrkProductHotspot extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.element = null;

    this.carousel = null;
  }
  connectedCallback() {
    // 使用全局的IntersectionObserver来进行懒加载初始化
    if (window.merakiUtils && window.merakiUtils.lazyObserver) {
      window.merakiUtils.lazyObserver.observe(this);
    } else {
      // 如果没有懒加载的IntersectionObserver直接初始化，避免组件用不了
      this.init();
    }
  }
  init() {
    this.element = this.getElements();
    this.carousel = this.querySelector('l-mrk-carousel');
    this.bindEvent();
  }
  getElements() {
    return {
      hotspotBtnNodes: this.querySelectorAll('[hotspot-btn]'),
      hotspotCloseNode: this.querySelector('[hotspot-close]'),
      hotspotContentNode: this.querySelector('[hotspot-content]')
    }
  }
  bindEvent() {
    const windowWidth = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    if (windowWidth > 990) {
      this.addEventListener('click', (e) => {
        this.setHotspotBtn(e);
      })
    } else {
      this.addEventListener('touchend', (e) => {
        e.preventDefault();
        this.setHotspotBtn(e, true);
      })
    }

    if (this.element.hotspotCloseNode) {
      this.element.hotspotCloseNode.addEventListener('click', () => {
        this.element.hotspotCloseNode.removeAttribute('open');
        this.element.hotspotContentNode.removeAttribute('open');
      })
    }
  }
  setHotspotBtn(e, isScroll = false) {
    const btn = e.target.closest('[hotspot-btn]');
    const anchorWrap = this.querySelector('[data-anchor-wrap]'); // 锚点容器位置，点击按钮好滚动到对应位置

    if (btn) {
      this.element.hotspotContentNode.setAttribute('open', 'true');
      this.element.hotspotCloseNode.setAttribute('open', '');

      if (anchorWrap && isScroll) {
        const windowScrollTop = window.scrollY || document.documentElement.scrollTop;

        let sectionOffsetTop = 0;
        if (window.merakiUtils && window.merakiUtils.getDocumentTop) {
          sectionOffsetTop = window.merakiUtils.getDocumentTop(anchorWrap);
        }
        if (sectionOffsetTop > 0) {
          if (sectionOffsetTop > windowScrollTop) {
            window.scrollTo({ top: sectionOffsetTop, behavior: 'smooth' });
          }
        }
      }

      if (this.carousel) {
        const btnCurrentIndex = parseFloat(btn.getAttribute('hotspot-btn-index'));
        this.carousel.customSwitch(btnCurrentIndex);
      }
    }
  }
}
customElements.define("mrk-product-hotspot", MrkProductHotspot);

/**
 * 产品前后 / 左右对比滑块 组件
 */
class MrkComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.element = null;

    this.boxWidth = 0;
    this.currentPageX = 0;
    this.resizeTimer = null;
  }
  connectedCallback() {
    // 使用全局的IntersectionObserver来进行懒加载初始化
    if (window.merakiUtils && window.merakiUtils.lazyObserver) {
      window.merakiUtils.lazyObserver.observe(this);
    } else {
      // 如果没有懒加载的IntersectionObserver直接初始化，避免组件用不了
      this.init();
    }
  }
  init() {
    this.lastWindowWidth = window.innerWidth; // 上一次窗口宽度
    this.element = this.getElements();
    this.getDimensions();
    this.setStyles();
    this.bindEvent();
  }
  getElements() {
    return {
      boxBlockNode: this.querySelector('[box-block]'),
      moveBtnNode: this.querySelector('[move-btn]'),
      itemBoxNode: this.querySelectorAll('[item-box]')
    }
  }
  getDimensions() {
    this.boxWidth = this.element.boxBlockNode.clientWidth;
    this.element.itemBoxNode.forEach((itemBoxNode) => {
      itemBoxNode.style.setProperty('--item-box-width', `${this.boxWidth}px`);
    })
  }
  setStyles() {
    this.currentPageX = this.boxWidth * 0.6;
    this.element.boxBlockNode.style.setProperty('--visible-width', `${this.currentPageX}px`);
  }
  bindEvent() {
    let isDragging = false;
    let dragStartX = 0;
    let walk = 0;
    this.element.boxBlockNode.addEventListener('mousedown', (e) => {
      e.preventDefault();
      const btnNode = e.target.closest('[move-btn]');
      if (!btnNode || isDragging) return;
      isDragging = true;
      dragStartX = e.pageX;
    })
    this.element.boxBlockNode.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const moveX = dragStartX - e.pageX;
      walk = this.currentPageX - moveX;
      if (walk <= 0) {
        walk = 0;
      } else if (walk >= this.boxWidth) {
        walk = this.boxWidth;
      }
      this.element.boxBlockNode.style.setProperty('--visible-width', `${walk}px`);
    })
    this.element.boxBlockNode.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      this.currentPageX = walk;
      walk = 0;
    })
    this.element.boxBlockNode.addEventListener('mouseleave', (e) => {
      if (!isDragging) return;
      isDragging = false;
      this.currentPageX = walk;
      walk = 0;
    })

    this.element.boxBlockNode.addEventListener('touchstart', (e) => {
      const btnNode = e.target.closest('[move-btn]');
      if (!btnNode) return;
      isDragging = true;
      dragStartX = e.touches[0].clientX;
    });

    this.element.boxBlockNode.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const moveX = dragStartX - e.touches[0].clientX;
      walk = this.currentPageX - moveX;
      if (walk <= 0) {
        walk = 0;
      } else if (walk >= this.boxWidth) {
        walk = this.boxWidth;
      }
      this.element.boxBlockNode.style.setProperty('--visible-width', `${walk}px`);
    }, { passive: false });

    this.element.boxBlockNode.addEventListener('touchend', () => {
      if (!isDragging) return;
      isDragging = false;
      this.currentPageX = walk;
      walk = 0;
    });

    this.element.boxBlockNode.addEventListener('touchcancel', () => {
      if (!isDragging) return;
      isDragging = false;
      this.currentPageX = walk;
      walk = 0;
    });

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        const currentWidth = window.innerWidth;
        if (currentWidth !== this.lastWindowWidth) {
          this.lastWindowWidth = currentWidth;
          this.getDimensions();
          this.setStyles();
        }
      }, 150);
    });
  }
}
customElements.define("mrk-comparison-slider", MrkComparisonSlider);

document.addEventListener('DOMContentLoaded', () => {
  // 产品 pdp 页面邮件联系客服，劫持提交事件
  const productEmailUsForm = document.querySelector('#product-email-us-form');
  if (productEmailUsForm) {
    const submitButtonNode = productEmailUsForm.querySelector('.button');
    if (submitButtonNode) {
      submitButtonNode.addEventListener('click', (e) => {
        e.preventDefault();
        const formNode = e.target.closest('form');
  
        const statusSuccessNode = formNode.querySelector('.contact-us-form__success');
        const statusErrorNode = formNode.querySelector('.contact-us-form__errors');
        const statusErrorListNode = formNode.querySelector('.contact-us-form__errors-list');
        const loadingSpinnerNode = formNode.querySelector('.loading__spinner ');
  
        const isFormValid = productEmailUsForm.checkValidity();
        if (!isFormValid) {
          productEmailUsForm.reportValidity();
          return;
        }
  
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(formNode);
        config.body = formData;
  
        const url = formNode.getAttribute('action');
        if (!url) return;
  
        if (loadingSpinnerNode) loadingSpinnerNode.classList.remove('hidden');
        if (statusSuccessNode) statusSuccessNode.classList.remove('show');
        if (statusErrorNode) statusErrorNode.classList.remove('show');
        if (statusErrorListNode) statusErrorListNode.innerHTML = '';
  
        submitButtonNode.setAttribute('disabled', true);
        fetch(`${url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              let errorHtml = '';
              if (response.msg && typeof response.msg == 'object') {
                for (const key in response.msg) {
                  errorHtml += `<li>${response.msg[key]}</li>`;
                }
              } else {
                errorHtml += `<li>${response.msg}</li>`;
              }
              if (statusErrorListNode) statusErrorListNode.innerHTML = errorHtml;
              if (statusErrorNode) statusErrorNode.classList.add('show');
              return;
            }
            if (statusSuccessNode) statusSuccessNode.classList.add('show');
          })
          .catch((e) => {
            if (statusErrorNode) statusErrorNode.classList.add('show');
          })
          .finally(() => {
            submitButtonNode.removeAttribute('disabled');
            if (loadingSpinnerNode) loadingSpinnerNode.classList.add('hidden');
          });
      })
    }
  }

  /* ============== ptengine 事件上报 start ============== */
  try {
    /**
     * 高级视频监听脚本
     * 1. 5s 轮询机制确保元素加载
     * 2. 监听暂停事件 (pause)
     * 3. 监听可见性变化 (IntersectionObserver)
     * 4. 自动防止重复绑定
     * 5. 深度优先搜索（支持穿透 Shadow DOM）
     * 6. MutationObserver 监听动态插入的 video (解决延迟加载问题)
     */
    function initSliderVideoTracker() {
      const processedVideos = new WeakSet();
      const logCurrentTime = (video, reason) => {
        window.ptengine && ptengine.track("firstVideo", { currentTime: video.currentTime.toFixed(2)});
      };
      // 核心：在指定容器内寻找所有 video，包括嵌套在 Shadow Root 里的
      const findVideosDeep = (root) => {
        let results = [];
        if (!root) return results;
        // 检查当前元素下的视频
        const videos = root.querySelectorAll('video');
        results.push(...Array.from(videos));
        // 穿透 Shadow DOM 继续查找
        const allElements = root.querySelectorAll('*');
        allElements.forEach(el => {
          if (el.shadowRoot) {
            results.push(...findVideosDeep(el.shadowRoot));
          }
        });
        return results;
      };
      const bindVideoEvents = (video) => {
        if (processedVideos.has(video)) return;
        // 1. 暂停事件监听
        video.addEventListener('pause', () => {
          if (!video.ended) logCurrentTime(video, '用户点击暂停');
        });
        // 2. 可见性监听
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting && !entry.target.paused) {
              logCurrentTime(entry.target, '视频移出可视区域');
            }
          });
        }, { threshold: 0 });
        observer.observe(video);
        processedVideos.add(video);
        // console.log('成功绑定新视频元素:', video);
      };
      // 初始化查找
      const slider = document.querySelector('slider-component');
      if (!slider) {
        // console.warn('未找到 slider-component 容器');
        return;
      }
      //监听手机端视频加载节点
      const videoSP = document.querySelector('product-modal');
      // 处理现有视频
      findVideosDeep(slider).forEach(bindVideoEvents);
      // 关键：监听动态插入（处理点击播放后才生成的 video）
      const domObserver = new MutationObserver((mutations) => {
        mutations.forEach(() => {
          findVideosDeep(slider).forEach(bindVideoEvents);
        });
      });
      const videoSPObserver = new MutationObserver((mutations) => {
        mutations.forEach(() => {
          if(videoSP){
            findVideosDeep(videoSP).forEach(bindVideoEvents);
          }
        });
      });
      domObserver.observe(slider, { childList: true, subtree: true });
      if(videoSP){
        videoSPObserver.observe(videoSP, { childList: true, subtree: true });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSliderVideoTracker);
    } else {
      initSliderVideoTracker();
    }
  } catch (error) {
  }
  /* ============== ptengine 事件上报 end ============== */
});